/** CMS analytic slug for the modal nudging eligible users to add a business profile */
export const BUSINESS_PROFILE_MODAL_ANALYTIC_SLUG = 'entry_modal_add_business_profile'
